/**
 * Đóng toàn bộ dropdown/popup đang mở khi scroll page hoặc scroll container nội bộ.
 *
 * Vì sao cần: popup Quasar (QSelect/QMenu/QPopupProxy...) chỉ reposition theo window scroll
 * (position-engine dùng getScrollTarget - chỉ match class .scroll/.scroll-y/.overflow-auto).
 * Với scroller nội bộ (vd .dashboard-content overflow-y:auto) popup không reposition -> bị lệch/trôi.
 * Thay vì sửa từng dropdown, đăng ký 1 lần global:
 * - window scroll capture: bắt scroll của MỌI scroll container (scroll không bubble nhưng có capture).
 * - "đóng" bằng cách dispatch mousedown/click ngoài popup -> kích hoạt đúng cơ chế
 *   click-outside mà Quasar (và hầu hết dropdown custom) đã tự register khi mở.
 *
 * Guard:
 * - Không dispatch khi scroll xảy ra BÊN TRONG popup/dialog đang mở (vd cuộn list option,
 *   cuộn nội dung modal) -> chỉ scroll content page/container mới đóng.
 * - Chỉ dispatch khi có popup đang mở trong DOM -> tránh fake event vô nghĩa mỗi lần scroll.
 */
const POPUP_SELECTOR = '.q-menu, .q-popup, .q-dialog, .q-tooltip, .q-date, .q-time, .popover, .dropdown-menu';

let registered = false;

function hasOpenPopup() {
  return document.querySelector(POPUP_SELECTOR) !== null;
}

function isScrollInsidePopup(target) {
  return target && target.nodeType === 1 && target.closest && target.closest(POPUP_SELECTOR) !== null;
}

/**
 * Đóng popup bằng cú mousedown/click ngoài (target = body, ngoài anchor + ngoài menu).
 * Quasar click-outside xử lý mousedown; 1 số dropdown custom chỉ nghe click -> gửi cả 2.
 */
function closeOpenPopups() {
  document.body.dispatchEvent(new MouseEvent('mousedown', { bubbles: true, cancelable: true }));
  document.body.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
}

export function initClosePopupOnScroll() {
  if (registered) {
    return;
  }
  registered = true;

  window.addEventListener(
    'scroll',
    (e) => {
      // Scroll trong chính popup/dialog đang mở -> KHÔNG đóng
      if (isScrollInsidePopup(e.target) === true) {
        return;
      }
      if (hasOpenPopup() === true) {
        closeOpenPopups();
      }
    },
    true
  );
}

export default initClosePopupOnScroll;
